import React, { useState } from "react";

import AuthenticationModal, {
  LOG_IN,
  SIGN_UP,
} from "../../Modals/AuthenticationModal";

const HeaderAccountSectionLoggedOut = () => {
  const [activeAuthModal, setActiveAuthModal] = useState<string | undefined>(
    undefined
  );

  return (
    <div className="paragraph-small">
      <button
        className="hover:text-dusty-gray mx-2 px-2 py-2 tracking-wide text-lapel hover:text-black no-underline cursor-pointer"
        onClick={() => {
          setActiveAuthModal(LOG_IN);
        }}
      >
        Log in
      </button>
      <div className="inline-block w-px h-3 align-middle bg-alto" />
      <button
        className="mx-2 px-2 py-2 tracking-wide text-lapel hover:text-black no-underline cursor-pointer"
        onClick={() => {
          setActiveAuthModal(SIGN_UP);
        }}
      >
        Sign up
      </button>
      {activeAuthModal && (
        <AuthenticationModal
          initialContent={activeAuthModal}
          isOpen={!!activeAuthModal}
          onDismiss={() => {
            setActiveAuthModal(undefined);
          }}
        />
      )}
    </div>
  );
};

export default HeaderAccountSectionLoggedOut;
